import csc from 'country-state-city'

const handleUSACountry = country => country === 'EUA' ? 'US' : country

const getStatesOfCountry = country => csc.getStatesOfCountry(handleUSACountry(country))

const getCitiesOfState = (country, state) => csc.getCitiesOfState(handleUSACountry(country), state)

const getCountryByCode = country => csc.getCountryByCode(handleUSACountry(country))

const getStateByCodeAndCountry = (country, state) => csc.getStateByCodeAndCountry(state, country)

export {
  getStatesOfCountry,
  getCitiesOfState,
  getCountryByCode,
  getStateByCodeAndCountry
}
